import { render } from "./NotificationView.vue?vue&type=template&id=5433eaae"
import script from "./NotificationView.vue?vue&type=script&lang=js"
export * from "./NotificationView.vue?vue&type=script&lang=js"

import "./NotificationView.vue?vue&type=style&index=0&id=5433eaae&lang=css"

import exportComponent from "/home/user_ui/taichung_main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__